import React,{useState,useEffect} from 'react';
import Navigation from './Navigation';

const NavigationContainer = (props :any) => {

    const [headerNav, setHeaderNav] = useState(false)

    const onToggleHeaderMenu = () => {
        setHeaderNav(!headerNav)
    }

    useEffect(() => {
        const windowResize = () => {
            let width = window.innerWidth
            if (width < 600) {
                setHeaderNav(false)
            } else {
                setHeaderNav(true)
            }
        }
        windowResize()
        window.addEventListener('resize', windowResize)
    }, [])

    return (
        <Navigation {...props} headerNav={headerNav} onToggleHeaderMenu={onToggleHeaderMenu}/>
    );
};

export default NavigationContainer;